import React from 'react'
import style from '../scss/components/FreeLessonVideo.module.scss'
import Button from './Button'
import {RootStateOrAny, useDispatch, useSelector} from 'react-redux'
import {pauseLessonVideo, playLessonVideo} from '../actions/videoPlayer'
import { Fade } from "react-awesome-reveal"
import VideoPlayer from "./VideoPlayer"

const FreeLessonVideo = () => {
    const videoUrl = 'https://player.vimeo.com/video/693249957'
    const dispatch = useDispatch()
    const playing = useSelector((state: RootStateOrAny) => state.videoPlayer.lesson_video_playing)
    const paused = useSelector((state: RootStateOrAny) => state.videoPlayer.lesson_video_paused)
    const playVideo = () => dispatch(playLessonVideo(true))
    const pauseVideo = () => dispatch(pauseLessonVideo(true))

    return (
        <Fade direction={'up'} triggerOnce={true}>
            <div className={style.Wrapper}>
                <div className={style.HeaderContainer}>
                    <h2>“SalonSecrets 7S mudeli I osa – Shopping”</h2>
                    <h3>Vaata tasuta lühikest klippi koolitusest:</h3>
                </div>
                <div className={style.VideoWrapper}>
                    <VideoPlayer
                        url={videoUrl}
                        placeholderVideoUrl={'/salonsecrets/video/lesson.mp4'}
                        playing={playing}
                        paused={paused}
                        onVideoPlay={playVideo}
                        onVideoPause={pauseVideo}
                        showBgImage={false}
                    />
                </div>
                <div className={style.ButtonContainer}>
                    <Button inverted={true} onClick={() => window.location.href = '#offer'}>
                        Vaata kogu veebikursust
                    </Button>
                </div>
            </div>
        </Fade>
    )
}

export default FreeLessonVideo
